<dx-box width="100%" height="100%" direction="col">
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <cc-data-grid-features [dataSource]="source">
                <dx-data-grid
                    width="100%"
                    height="100%"
                    class="cc-vertical-center-cell-data-grid"
                    [dataSource]="source"
                    [columns]="columns"
                    [keyExpr]="keyExpr"
                    [noDataText]="noDataText"
                    [filterRow]="filterRow"
                    [selection]="selectionMode"
                    (onSelectionChanged)="onSelectionChanged($event)"
                >
                    <div *dxTemplate="let t of 'selectButtonTemplate'">
                        <dx-button
                            type="default"
                            text="Select"
                            [icon]="iconCheck"
                            [width]="84"
                            [height]="26"
                            (onClick)="onSelectClick(t.data)"
                        ></dx-button>
                    </div>
                    <div *dxTemplate="let t of 'selectRadioTemplate'">
                        <input
                            name="selection"
                            type="radio"
                            [checked]="isSelectedRow(t.data)"
                            (click)="onSelectClick(t.data)"
                        />
                    </div>
                    <div *dxTemplate="let row of 'booleanIconTemplate'">
                        <i *ngIf="row.value" class="cc-check-icon cc-1-5x" [ngClass]="iconCheck"></i>
                        <i *ngIf="!row.value" class="cc-cross-icon cc-1-5x" [ngClass]="iconCross"></i>
                    </div>
                    <div *dxTemplate="let row of 'activeIconTemplate'">
                        <i *ngIf="row.value" class="cc-check-icon cc-1-5x" [ngClass]="iconCheck"></i>
                    </div>
                </dx-data-grid>
            </cc-data-grid-features>
        </div>
    </dxi-item>
</dx-box>
